import { applyFilter, applySearchFilter } from '../../Utils/Utils';

export const applyFilters = ({ list, filters }) => {
  let filteredList = list;
  // filter on start_date
  filteredList = applyFilter({
    list: filteredList,
    filters,
    rowName: 'start_date',
    defaultFilter: [],
  });
  // filter on end_date
  filteredList = applyFilter({
    list: filteredList,
    filters,
    rowName: 'end_date',
    defaultFilter: [],
  });
  // filter on end_date
  filteredList = applyFilter({
    list: filteredList,
    filters,
    rowName: 'questionnaire',
    defaultFilter: [],
  });
  // query filter on field: id, code, rec_name
  filteredList = applySearchFilter({
    list: filteredList,
    filters: { query: filters.query },
    rowNames: ['id', 'status', 'questionnaire'],
  });
  // queryName filter on field: coveredsLabel, subscribersLabel
  filteredList = applySearchFilter({
    list: filteredList,
    filters: { query: filters.queryName },
    rowNames: ['coveredsLabel', 'subscribersLabel'],
  });

  return filteredList;
};
